module.exports = __webpack_public_path__ + "media/images/icon/icons8-Maintenance-aa3b74409054298eee51b14bd5ee9212.png";